export default __webpack_public_path__ + "static/media/logo-airbus.3cb6f46b.svg";